import { render } from "./GenericTabView.vue?vue&type=template&id=fde35312"
import script from "./GenericTabView.vue?vue&type=script&lang=js"
export * from "./GenericTabView.vue?vue&type=script&lang=js"

import "./GenericTabView.vue?vue&type=style&index=0&id=fde35312&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__